import { RefObject, useState } from "react";
import { exportFromTableToExcel } from "@/shared/utils/xlsx";
import { exportFromTableToPdf } from "@/shared/utils/pdf";
import { useReactToPrint } from "react-to-print";
import ModalConfirmarAcao from "@/shared/components/modals/ModalProximaAcao";

interface ComponentProps {
  imprimindo: boolean,
  htmlTableId: string,
  htmlHeaders: string[]
  orientation?: "p" | "portrait" | "l" | "landscape"
  printJsxToPdf: () => void
  htmlRef?: RefObject<HTMLDivElement>;
}

/**
 * Botão de exportar para a tabela de movimentos.
 * @param param0 
 * @returns 
 */
export function ExportButton({ imprimindo, htmlTableId, htmlHeaders, printJsxToPdf, htmlRef, orientation = 'p' }: ComponentProps) {

  const [modalConfirmacao, setModalConfirmacao] = useState(false)

  const printReactToPdf = useReactToPrint({
    contentRef: htmlRef,
    pageStyle: `
      @page { size: ${orientation === "l" || orientation === "landscape" ? "landscape" : "portrait"}; }
      body { -webkit-print-color-adjust: exact; }
    `,
  });


  return <>
    <button type="button" data-bs-toggle="dropdown" disabled={imprimindo} className="btn btn-sm btn-outline-secondary dropdown-toggle float-end mb-2">
      Exportar
    </button>
    <div className="dropdown-menu float-end">
      <button className="dropdown-item" title="Planilha do Excel." onClick={() => exportFromTableToExcel(htmlTableId)}>
        Excel
      </button>
      <hr className="m-0 p-0 mb-1 mt-1" />
      <button
        className="dropdown-item"
        title="Bonito."
        style={{ display: "none" }}
        onClick={() => setModalConfirmacao(true)}
      >
        PDF Estilizado
      </button>

      <button className="dropdown-item" title="Estável." onClick={printReactToPdf} >
        PDF Automático
      </button>
      <button className="dropdown-item" title="Rápido." onClick={() => exportFromTableToPdf(htmlTableId, htmlHeaders, orientation)}>
        PDF Simples
      </button>
    </div>

    <ModalConfirmarAcao
      show={modalConfirmacao}
      handleHide={() => { setModalConfirmacao(false) }}
      tituloBotaoPrincipal="Gerar PDF"
      tituloDaCaixaDeTexto="Gerar PDF?"
      corpoDaCaixaDeTexto="Criar um documento PDF para essas informações?"
      handleAcaoPrincipal={printJsxToPdf}
    />
  </>
}